type Messages = {
  [key in string]: {
    loginMismatch: {
      title: string;
      description: (provider: string) => string;
      submitText: string;
      secondaryText: string;
      email: string;
      google: string;
      apple: string;
    };
    loginWithSso: {
      title: string;
      description: (provider: string) => string;
      submitText: (provider: string) => string;
      secondaryText: string;
      email: string;
      google: string;
      apple: string;
    };
  };
};

const messages: Messages = {
  eng: {
    loginMismatch: {
      title: 'Login Method Mismatch',
      description: (
        provider: string,
      ) => `Your account is currently configured to log in with an email and password.
<br />
<br />
To link your ${provider} to your profile, select “Link My Account” below, log in to your account using your email address and password, and follow the on screen prompts.
`,
      submitText: 'Link My Account',
      secondaryText: 'Need help?',
      email: 'Email and password',
      google: 'Google account',
      apple: 'Apple account',
    },
    loginWithSso: {
      title: 'Update Login Method',
      description: (
        provider: string,
      ) => `You’re attempting to use a login method that you haven’t authorised.
<br />
<br />
Please log in with your ${provider} or update your log in method.
<br />
<br />
Note: changing your login method will disable withdrawals from your account for 24 hours.`,
      submitText: (provider: string) => `Continue with ${provider}`,
      secondaryText: 'Login with email',
      email: 'Email and password',
      google: 'Google account',
      apple: 'Apple account',
    },
  },
};

export default messages;
